export default "__VITE_ASSET__CUkm6kbf__"